// extracted by mini-css-extract-plugin
export default {"rowCards":"Cards_rowCards__7FEAm"};